import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxBulletModule } from 'devextreme-angular/ui/bullet';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DataGridComponent } from './data-grid.component';
import { DataGridService } from './data-grid.service';


@NgModule({
  imports: [CommonModule, DxDataGridModule, DxTemplateModule, DxBulletModule],
  declarations: [DataGridComponent],
  exports: [DataGridComponent],
  providers: [DataGridService]
})
export class DataGridModule { }

